import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { fmtNum, Panel, PageHeader, Th, Td, Empty, StatusPill } from "@/components/admin/parts";

export default function Content() {
  const [items, setItems] = useState(null);
  useEffect(() => { adminApi.content().then((d) => setItems(d.items)).catch(() => {}); }, []);

  const totalPrompts = items?.reduce((s, p) => s + (p.prompts || 0), 0) || 0;

  return (
    <div>
      <PageHeader title="Treści i prompty" subtitle="Przegląd katalogu pakietów i promptów" />
      <Panel testId={ADMIN.contentTable} action={items && <span className="text-sm text-brand-sec">{items.length} pakietów · {fmtNum(totalPrompts)} promptów</span>}>
        {!items ? <Empty>Ładowanie…</Empty> : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[560px]">
              <thead><tr className="border-b border-brand-line">
                <Th>Pakiet</Th><Th>Slug</Th><Th className="text-right">Kategorie</Th><Th className="text-right">Prompty</Th><Th>Status</Th>
              </tr></thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.slug} className="border-b border-brand-line/60">
                    <Td className="font-medium text-brand-text">{p.name}</Td>
                    <Td className="text-brand-muted">{p.slug}</Td>
                    <Td className="text-right">{fmtNum(p.categories)}</Td>
                    <Td className="text-right font-semibold text-brand-accent">{fmtNum(p.prompts)}</Td>
                    <Td><StatusPill status={p.status === "ACTIVE" ? "ACTIVE" : "ZAMKNIETA"} label={p.status} /></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <p className="mt-4 text-xs text-brand-muted">Edycja treści promptów odbywa się przez import danych (data_import). Podgląd tylko do odczytu.</p>
      </Panel>
    </div>
  );
}
